import { useState } from "react";
import { Lock, RotateCcw, ShieldCheck } from "lucide-react";
import { Arrow, Skeleton } from "@/components/hm/Basics";
import { usePlans, euros } from "@/lib/plans";


const Check = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M20 6 9 17l-5-5" /></svg>;
const Dash = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 12h12" /></svg>;

const PlanCard = ({ p, interval, onChoose, loading, current, ctaLabel }) => (
  <article className={`plan rv ${p.popular ? "pop" : ""} ${current ? "plan-cur" : ""}`} data-testid={`plan-card-${p.id}`}>
    <div className="plan-top">
      <span className="plan-name">{p.title}</span>
      {current ? <span className="chip">Tu plan</span> : p.popular && <span className="chip">El más elegido</span>}
    </div>
    <div>
      <div className="price"><b data-testid={`plan-price-${p.id}`}>{euros(interval === "month" ? p.amount : p.yearly_amount)}</b><span>/ {interval === "month" ? "mes" : "año"}</span></div>
      <div className="price-note" style={{ marginTop: ".4rem" }}>{interval === "year" ? `Equivale a unos ${euros(Math.round(p.yearly_amount / 12))} al mes` : "\u00a0"}</div>
    </div>
    <ul>
      {p.features.map((f) => <li key={f}><Check />{f}</li>)}
      {p.off?.map((f) => <li key={f} className="off"><Dash />{f}</li>)}
    </ul>
    <button className={`btn ${p.popular ? "btn-primary mag" : "btn-ghost"}`} disabled={loading || current}
      onClick={() => onChoose(p.id, interval)} data-testid={`plan-choose-${p.id}`}>
      {current ? "Es tu plan actual" : loading ? "Abriendo el pago..." : ctaLabel}{!current && !loading && p.popular && <Arrow />}
    </button>
  </article>
);

export const Pricing = ({ onChoose, loadingId, currentPlan, ctaLabel = "Elegir este plan" }) => {
  const [interval, setInterval] = useState("month");
  const plans = usePlans();
  const free = plans?.length ? Math.round(12 - plans[0].yearly_amount / plans[0].amount) : 0;
  return (
    <div style={{ textAlign: "center" }}>
      <div className="bill" role="group" aria-label="Periodo de pago">
        <button className={interval === "month" ? "on" : ""} onClick={() => setInterval("month")} data-testid="billing-monthly">Mensual</button>
        <button className={interval === "year" ? "on" : ""} onClick={() => setInterval("year")} data-testid="billing-yearly">Anual {free > 0 && <em>{free === 1 ? "1 mes gratis" : `${free} meses gratis`}</em>}</button>
      </div>
      <div className="plans" style={{ textAlign: "left" }}>
        {!plans && <Skeleton n={3} h={320} />}
        {plans?.map((p) => (
          <PlanCard key={p.id} p={p} interval={interval} onChoose={onChoose} loading={loadingId === p.id}
            current={currentPlan === p.id} ctaLabel={ctaLabel} />
        ))}
      </div>
      <div className="pay-trust">
        <span><Lock />Pago seguro con Stripe</span>
        <span><RotateCcw />Cancela cuando quieras desde tu cuenta</span>
        <span><ShieldCheck />No compartimos tus datos con terceros</span>
      </div>
    </div>
  );
};
